
import React, { useEffect, useState } from "react";
import {
  FloatButton,
  Drawer,
  Select,
  DatePicker,
  Button,
  Skeleton,
} from "antd";





import {
  generatedISOFormatDateString,
  roundOffValue,
  roundToTwoDecimalPlaces,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from '../../../../../Elements/CustomDrawer';
import CustomSelect from '../../../../../Elements/CustomSelect';
import TreeSelectCustomWithSelectAll from '../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect';
import TreeSelectCustom from '../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustom';
import RawGrid from '../../../../../Elements/Grid/Grid';
import ExportToExel from '../../../../../Elements/Grid/Export';
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import SteamTreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import TableComponent from "../../../../../Elements/Grid/TableComponent";



const TempRawDataGrid = () => {
  const {  makeRequest } = useStoreUpdaterWithAPI();
    const [sectionId, setSectionId] = useState();
    const [converterGroupId, setConverterGroupId] = useState();
    const [report, setReport] = useState(null)
    const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState(); 
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [chartSkip, setChartSkip] = useState();
  const [chartInput, setChartInput] = useState();

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState(); 
  const [loading, setLoading] = useState(false); 

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);

  const [steamRawData,setsteamRawData] = useState([]);
  const [loadings, setLoadings] = useState(true);
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(()=>{
    simulateLoading(setLoadings);
  },[])


  let formattedFromDate; 
  let formattedToDate;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const dummyResponse = [
    {
        "sitE_ID": 9,
        "workstation": "SalComp",
        "sitename": "S9",
        "comport": "com4",
        "baudrate": "4200",
        "databits": "",
        "parity": "none",
        "stopbit": "1",
        "delete_yn": 1,
        "siteIP": "192.168.0.14",
        "port": "4001",
        "noofPorts": 1,
        "electricityModule": 0,
        "steamModule": 0,
        "waterModule": 0,
        "airModule": 0,
        "gasModule": 0,
        "temperatureModule": 0
    },
    {
        "sitE_ID": 10,
        "workstation": "SalComp",
        "sitename": "S10",
        "comport": "com4",
        "baudrate": "4200",
        "databits": "",
        "parity": "none",
        "stopbit": "1",
        "delete_yn": 1,
        "siteIP": "192.168.0.12",
        "port": "4001",
        "noofPorts": 1,
        "electricityModule": 0,
        "steamModule": 0,
        "waterModule": 0,
        "airModule": 0,
        "gasModule": 0,
        "temperatureModule": 0
    }
]

const dummyData= [
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:59:15.68"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:59:09.28"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:59:08.233"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:58:12.197"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:58:05.77"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:58:04.747"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:57:08.77"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:57:02.38"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:57:01.35"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:56:05.297"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:55:58.91"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:55:57.877"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:55:01.83"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:54:55.413"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:54:54.373"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:53:58.36"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:53:51.957"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:53:50.93"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:52:54.91"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:52:48.513"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:52:47.483"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:51:51.493"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:51:45.087"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:51:44.043"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:50:47.93"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:50:41.51"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:50:40.47"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:49:44.483"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:49:38.093"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:49:37.06"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:48:40.98"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:48:34.6"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:48:33.57"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:47:37.607"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:47:31.19"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:47:30.137"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:46:34.153"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:46:27.773"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:46:26.75"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:45:30.593"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:45:24.207"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:45:23.187"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:44:27.133"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:44:20.717"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:44:19.693"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:43:23.717"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:43:17.317"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:43:16.297"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:42:20.257"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:42:13.847"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:42:12.807"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:41:16.797"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:41:10.403"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:41:09.39"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:40:13.477"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:40:07.07"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:40:06.037"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:39:09.99"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:39:03.603"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:39:02.577"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:38:06.51"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:38:00.123"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:37:59.097"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:37:03.117"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:36:56.713"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:36:55.673"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:35:59.53"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:35:53.15"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:35:52.113"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:34:56.13"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:34:49.727"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:34:48.693"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:33:52.63"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:33:46.217"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:33:45.187"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:32:49.143"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:32:42.77"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:32:41.737"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:31:45.72"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:31:39.343"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:31:38.313"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:30:42.207"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:30:35.8"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:30:34.773"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:29:38.89"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:29:32.473"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:29:31.443"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:28:35.427"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:28:29.04"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:28:28.017"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:27:32.017"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:27:25.603"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:27:24.58"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:26:28.737"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:26:22.367"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:26:21.35"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:25:25.397"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:25:18.997"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:25:17.96"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:24:21.96"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:24:15.583"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:24:14.553"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:23:18.53"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:23:12.15"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:23:11.117"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:22:15.157"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:22:08.767"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:22:07.75"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:21:11.697"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:21:05.313"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:21:04.303"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:20:08.327"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:20:01.917"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:20:00.9"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:19:04.833"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:18:58.433"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:18:57.403"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:18:01.34"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:17:54.913"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:17:53.9"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:16:57.907"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:16:51.53"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:16:50.497"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:15:54.573"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:15:48.147"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:15:47.127"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:14:51.19"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:14:44.773"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:14:43.737"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:13:47.763"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:13:41.36"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:13:40.337"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:12:44.277"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:12:37.883"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:12:36.84"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:11:40.86"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:11:34.447"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:11:33.407"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:10:37.29"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:10:30.89"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:10:29.867"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:09:33.913"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:09:27.527"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:09:26.487"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:08:30.57"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:08:24.183"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:08:23.16"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:07:27.19"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:07:20.78"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:07:19.757"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:06:23.783"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:06:17.367"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:06:16.333"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:05:20.327"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:05:13.933"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:05:12.907"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:04:16.927"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:04:10.547"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:04:09.523"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:03:13.46"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:03:07.05"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:03:06.003"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:02:10.043"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:02:03.647"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:02:02.617"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:01:06.65"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:01:00.267"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T02:00:59.253"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T02:00:03.207"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:59:56.783"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:59:55.747"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:58:59.723"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:58:53.35"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:58:52.327"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:57:56.35"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:57:49.927"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:57:48.903"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:56:52.823"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:56:46.443"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:56:45.41"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:55:49.357"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:55:42.99"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:55:41.95"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:54:45.98"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:54:39.57"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:54:38.54"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:53:42.487"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:53:36.107"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:53:35.073"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:52:39.05"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:52:32.647"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:52:31.627"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:51:35.643"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:51:29.253"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:51:28.227"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:50:32.197"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:50:25.8"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:50:24.773"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:49:28.663"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:49:22.263"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:49:21.223"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:48:25.323"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:48:18.923"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:48:17.91"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:47:21.95"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:47:15.557"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:47:14.52"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:46:18.46"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:46:12.073"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:46:11.04"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:45:15.063"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:45:08.673"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:45:07.647"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:44:11.59"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:44:05.22"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:44:04.177"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:43:08.27"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:43:01.87"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:43:00.837"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:42:04.78"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:41:58.39"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:41:57.34"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:41:01.387"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:40:54.987"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:40:53.94"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:39:58.047"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:39:51.64"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:39:50.623"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:38:54.64"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:38:48.257"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:38:47.223"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:37:51.29"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:37:44.877"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:37:43.843"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:36:47.743"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:36:41.35"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:36:40.31"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:35:44.277"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:35:37.86"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:35:36.84"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:34:40.863"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:34:34.47"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:34:33.45"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:33:37.503"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:33:31.097"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:33:30.057"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:32:33.977"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:32:27.577"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:32:26.537"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:31:30.49"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:31:24.093"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:31:23.073"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:30:27.063"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:30:20.667"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:30:19.637"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:29:23.633"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:29:17.243"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:29:16.187"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:28:20.213"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:28:13.833"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:28:12.81"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:27:16.893"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:27:10.503"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:27:09.493"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:26:13.47"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:26:07.087"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:26:06.043"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:25:10.057"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:25:03.66"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:25:02.613"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:24:06.6"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:24:00.213"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:23:59.183"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:23:03.24"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:22:56.83"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:22:55.797"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:21:59.737"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:21:53.35"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:21:52.33"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:20:56.33"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:20:49.92"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:20:48.877"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:19:52.78"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:19:46.36"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:19:45.323"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:18:49.29"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:18:42.89"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:18:41.863"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:17:45.923"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:17:39.53"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:17:38.503"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:16:42.53"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:16:36.137"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:16:35.12"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:15:39.233"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:15:32.833"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:15:31.803"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:14:35.78"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:14:29.38"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:14:28.357"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:13:32.353"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:13:25.967"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:13:24.933"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:12:28.99"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:12:22.573"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:12:21.56"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:11:25.593"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:11:19.193"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:11:18.167"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:10:22.223"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:10:15.853"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:10:14.837"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:09:19.033"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:09:12.67"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:09:11.653"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:08:15.953"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:08:09.533"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:08:08.503"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:07:12.8"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:07:06.453"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:07:05.43"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:06:09.707"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:06:03.347"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:06:02.307"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:05:06.667"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:05:00.31"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:04:59.293"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:04:03.577"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:03:57.22"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:03:56.193"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:03:00.46"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:02:54.08"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:02:53.06"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:01:57.353"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:01:50.96"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:01:49.93"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:00:53.88"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T01:00:47.487"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T01:00:46.45"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:59:50.457"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:59:44.07"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:59:43.02"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:58:47.047"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:58:40.647"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:58:39.627"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:57:43.593"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:57:37.217"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:57:36.18"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:56:40.07"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:56:33.673"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:56:32.647"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:55:36.663"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:55:30.257"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:55:29.233"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:54:33.307"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:54:26.893"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:54:25.857"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:53:29.883"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:53:23.487"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:53:22.473"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:52:26.567"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:52:20.137"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:52:19.087"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:51:23.043"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:51:16.65"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:51:15.617"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:50:19.653"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:50:13.253"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:50:12.227"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:49:16.137"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:49:09.74"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:49:08.707"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:48:12.703"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:48:06.317"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:48:05.29"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:47:09.3"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:47:02.95"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:47:01.93"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:46:05.947"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:45:59.54"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:45:58.51"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:45:02.443"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:44:56.05"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:44:54.997"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:43:58.96"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:43:52.573"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:43:51.547"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:42:55.617"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:42:49.21"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:42:48.183"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:41:52.18"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:41:45.77"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:41:44.74"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:40:48.767"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:40:42.373"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:40:41.353"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:39:45.407"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:39:39"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:39:37.977"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:38:41.94"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:38:35.52"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:38:34.493"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:37:38.413"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:37:32"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:37:30.967"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:36:35.02"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:36:28.647"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:36:27.62"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:35:31.597"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:35:25.203"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:35:24.17"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:34:28.2"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:34:21.813"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:34:20.79"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:33:24.74"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:33:18.323"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:33:17.293"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:32:21.313"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:32:14.923"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:32:13.893"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:31:17.883"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:31:11.493"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:31:10.467"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:30:14.44"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:30:08.057"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:30:07.03"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:29:11.007"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:29:04.623"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:29:03.6"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:28:07.607"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:28:01.197"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:28:00.157"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:27:04.167"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:26:57.753"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:26:56.72"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:26:00.77"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:25:54.39"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:25:53.363"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:24:57.39"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:24:50.963"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:24:49.947"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:23:54.023"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:23:47.637"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:23:46.61"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:22:50.667"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:22:44.267"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:22:43.23"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:21:47.18"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:21:40.78"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:21:39.753"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:20:43.81"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:20:37.417"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:20:36.39"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:19:40.383"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:19:33.997"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:19:32.977"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:18:36.853"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:18:30.46"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:18:29.437"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:17:33.567"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:17:27.193"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:17:26.157"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:16:30.197"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:16:23.813"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:16:22.793"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:15:26.877"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:15:20.497"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:15:19.46"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:14:23.39"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:14:17.01"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:14:15.993"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:13:20.03"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:13:13.653"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:13:12.61"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:12:16.647"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:12:10.227"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:12:09.213"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:11:13.213"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:11:06.793"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:11:05.76"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:10:09.797"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:10:03.407"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:10:02.387"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:09:06.403"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:08:59.987"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:08:58.943"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:08:03.013"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:07:56.597"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:07:55.553"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:06:59.553"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:06:53.157"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:06:52.113"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:05:56.043"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:05:49.647"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:05:48.637"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:04:52.627"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:04:46.203"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:04:45.173"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:03:49.153"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:03:42.76"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:03:41.717"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:02:45.67"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:02:39.3"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:02:38.26"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:01:51.657"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:01:45.297"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:01:44.27"
  },
  {
      "sitename": "S9",
      "meterid": 62,
      "metername": "Coil Area Temperature 3\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:00:48.21"
  },
  {
      "sitename": "S9",
      "meterid": 61,
      "metername": "Coil Area Temperature 2\r\n",
      "rh": 0,
      "temperature": 0,
      "createdON": "2024-10-09T00:00:41.82"
  },
  {
      "sitename": "S9",
      "meterid": 60,
      "metername": "Coil Area Temperature 1\r\n",
      "rh": 49,
      "temperature": 26,
      "createdON": "2024-10-09T00:00:40.793"
  }
]


  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowSectionResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        // url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
        url: `${APIConstants.TEMP_GETSITES}` 
      }).then((res) => {
        console.log(res)
        setgetFlowConverterResData(res);
        // setgetFlowConverterResData(dummyResponse);
      });

    makeRequest({  
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowGroupDetailsResData(res);
      });

   
  },[]);

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.TEMP_METERS_LIST}?SiteID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        setnsGetFlowConverterResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}` 
      }).then((res) => {
        console.log(res)
        setgetFlowSteamGroupMeterResData(res);
      });
  },[converterGroupId]);



  const getResponse =(inputData)=>{
    console.log(inputData)
    
    makeRequest({
        type: APIConstants.GET,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        // ?SectionID=1&ConverterorGroupID=22&MeterIds=29&FromDate=2024-7-16T12:04:18.000Z&ToDate=2024-7-17T12:04:22.000Z
        url: `${APIConstants.GET_RAWDATA_TEMPERATURE}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
      }).then((res) => {
        console.log(res)
        console.log(dummyData) 
        setsteamRawData(res);
      });
  }
  


  const inputData = {
    SectionID: 1,
    ConverterorGroupID: 2,
    MeterIds: "1",
    FromDate: "2023-09-21T07:15:00.000Z",
    ToDate: "2023-09-25T07:15:00.000Z",
  };


  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values) {
      setParaError("");
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };

  const setChartInputData = () => {
    // const [date, time] =  fromDateString?.split("T")
    // const [toDateSplit, toTimeSplit] =toDateString?.split("T")
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);

    const ids = selectedMeterIds?.map((id) => id).join(",");
    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 2,
      MeterIds: ids || 1,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
    };
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
    getResponse(inputData)
  };

  useEffect(() => {
    setChartInputData();
  }, []);

  const parameters = [
    { id: 1, name: "rh" },
    { id: 2, name: "temperature" },
  ];

  useEffect(() => {
    setChartSkip(false);
    updateChart();
  }, [chartInput, steamRawData, selectedValues]);

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError
    ) {
      onClose();
      setChartInputData();
    }
  };

  const findMaxMeter = (array) => {
    let maxMeter = array[0]?.name;
    let maxLength = array[0]?.data?.length;

    array?.forEach((arr) => {
      const currentLength = arr.data.length;

      if (currentLength > maxLength) {
        maxLength = currentLength;
        maxMeter = arr.name;
      }
    });
    return maxMeter;
  };

  const maxDates = (name, data, value) => {
    const modifiedString = name?.replace(/-temperature|-rh/g, "");
    const filteredData = data?.filter((d) => d[value] === modifiedString);
    if (filteredData?.length === 0) {
      return;
    }
    const dates = filteredData?.map((d) => d.createdON);
    return dates;
  };

  const bindData = (datesArray, data) => {
    const resultArray = [];
    datesArray?.forEach((date, index) => {
      const dataObject = { date: new Date(date).toLocaleString() };

      data?.forEach((item) => {
        if (item.data[index] >= 0) {
          dataObject[item.name] = item.data[index];
        } else {
          dataObject[item.name] = "-";
        }
      });

      resultArray.push(dataObject);
    });
    return resultArray;
  };

  const updateChart = async () => {
    console.log(steamRawData)
    try {
      const selectedMeterData = steamRawData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterid)
      );
      const firstOption = selectedValues.includes("rh");
      const secondOption = selectedValues.includes("temperature");
      selectedMeterData?.sort(
        (a, b) => new Date(a.createdON) - new Date(b.createdON)
      );

      console.log(selectedMeterIds)
      const transformData = (property, meterName) => {
        console.log(selectedMeterData)
        const data = selectedMeterData
          ?.filter((item) => item?.metername === meterName)
          ?.map((item) => item[property]);
        const seriesData = {
          name: `${meterName}-${property}`, // Concatenate property and METERNAME
          data,
        };
        return seriesData;
      };

      console.log(nsGetFlowConverterList)
      console.log(selectedMeterIds)
      const properties = selectedValues;
      const seriesData = [];
      selectedMeterIds?.forEach((id) => {
        const meterName = 
          sectionId === 1 
            ? nsGetFlowConverterList?.find(
                (item) => item?.meteR_METERID === Number(id)
              ).metername
            : getFlowSteamGroupMeterList?.find(
                (item) => item?.meterID === Number(id)
              ).meterName;
        properties.forEach((property) => {
          seriesData.push(transformData(property, meterName));
        });

      });
      console.log(seriesData)

      const maxCountMeter = findMaxMeter(seriesData);

      const maxDatesArray = maxDates(
        maxCountMeter,
        selectedMeterData,
        sectionId === 1 ? "metername"
         :
         "metername"
      );
      const tableData = bindData(maxDatesArray, seriesData);

      // Iterate over the map and create the transformed data
      tableData.forEach(({ metername, temperature, rh }, createdON) => {
        // Check if the date already exists in the tableData
        const date = new Date(createdON).setMilliseconds(0);
        const existingRow = tableData.find(
          (row) => row.date === new Date(date)
          .toLocaleString()
        );

        if (existingRow) {
          // If the date exists, update the existing entry with new values
          existingRow[`${metername}-temperature`] = temperature;
          existingRow[`${metername}-rh`] = rh;
          existingRow[`${metername}`] =
            temperature > rh ? temperature : rh;
        } else {
          // If the date doesn't exist, create a new entry
          const newRow = {
            date: new Date(date).toLocaleString(),
            [`${metername}-temperature`]: temperature,
            [`${metername}-rh`]: rh,
            [`${metername}`]: temperature > rh ? temperature : rh,
          };
          tableData.push(newRow);
        }
      });
    //   console.log(tableData.pop())
    tableData.pop()
 
      setReport(tableData);
    } catch (err) {
      console.log(err);
    }
  };

  const selectedMeters = () => {
    console.log(nsGetFlowConverterList)
    const meters = selectedMeterIds?.map((id) => {
      const meter =
        sectionId === 1
          ? nsGetFlowConverterList?.find((meter) => meter.meteR_METERID === id)
              ?.metername
          : getFlowSteamGroupMeterList?.find((meter) => meter.meterID === id)
              ?.meterName;
      return meter || ""; // Return an empty string if the meter is not found
    });
    const allmeters = [];
    const firstOption = selectedValues.includes("rh");
    const secondOption = selectedValues.includes("temperature");
    meters?.forEach((meter) => {
      if (firstOption && secondOption) {
        allmeters.push(meter + "-rh");
        allmeters.push(meter + "-temperature");
      } else if (firstOption) {
        allmeters.push(meter + "-rh");
      } else {
        allmeters.push(meter + "-temperature");
      }
    });

    return allmeters;
  };

    const mode = useSelector((state) => state.darkMode);

    const { isdarkMode } = mode;
    console.log(selectedMeters()) 
    console.log(report)

    function getDDMMYYYY() {
        let today = new Date();
        
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        let yyyy = today.getFullYear();
        
        return dd + '_' + mm + '_' + yyyy;
    }

  return (
    <div className="rounded-md w-auto">
    {/* {isMeterDataDetailsLoading && ( */}
      <>
        {/* <Skeleton active paragraph={{ rows: 20 }} className="mt-12 mx-3" /> */}
      </>
    {/* )} */}
    {/* {loading && ( */}
      <>
        {/* <Skeleton active paragraph={{ rows: 20 }} className="mt-12 mx-3" /> */}
      </> 
    {/* )} */}
    {/* <div className="flex justify-center">
      {isMeterDataDetailsError && 
      (
        <div className="flex flex-col">
          <img className="w-[150px] h-[80px] " src={errorNew} />
          <p className="text-sm text-red-500 text-center">Server error</p>
          <p className="text-center">Please reload the page</p>
        </div>
      )}
    </div> */}
 
    <div className="my-2 flex justify-end mr-2">
      {report?.length > 0 && (
        <ExportToExel
          report={report}
          meters={selectedMeters()}
          parameter={selectedValues?.length === 2}
          filename={getDDMMYYYY()}
        /> 
       )} 
    </div>

   
   {
    !loadings? 
      <div className={`m-2`}>
        <TableComponent
         report={report} 
         meters={selectedMeters()}
         parameter={selectedValues.length === 2}  
        />
      </div>:
       <>
       <Skeleton active paragraph={{ rows: 6 }} />
     </> 
   }


    <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            valueKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"
            nameKey="name"
            valueKey="name"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32  text-left">From Date:</label>
            <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={`   ${isdarkMode ? 'datebackground dateplaceholder ' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`  ${isdarkMode ? 'datebackground dateplaceholder' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {toDateError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
  </div>
  )
}

export default TempRawDataGrid
